export default "__VITE_ASSET__80122481__"